import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function MobilePhone({
  color = 'icon.primary',
  fill = 'transparent',
  stroke,
  ...props
}) {
  return (
    <IconBase viewBox='0 0 14 14' {...props}>
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.63326 8.239C6.41435 9.02009 7.28891 9.60891 8.17615 10.0001C8.36374 10.0829 8.58338
         10.0342 8.72825 9.8893L9.27501 9.34254C9.72297 8.89458 10.3565 8.89458 10.7477 9.28579L11.5308
          10.0696C12.0522 10.5909 12.0522 11.4361 11.5308 11.9575L11.0962 12.3928C10.6015 12.8875 9.88787
           13.0938 9.18021 12.9603C7.43578 12.6305 5.52578 11.617 3.89083 9.9821C2.25588 8.34715 1.24247
            6.43715 0.912674 4.69271C0.779155 3.98506 0.985442 3.2714 1.48013 2.77671L1.91474 2.3421C2.43613
             1.8207 3.28131 1.8207 3.80271 2.3421L4.5858 3.12519C4.97701 3.5164 4.97701 4.15062 4.5858
              4.54117L3.98229 5.14401C3.83742 5.28888 3.78869 5.50852 3.87147 5.69611C4.26335 6.58335
               4.85284 7.45791 5.63326 8.239Z'
        stroke={color}
        fill={fill}
        strokeWidth={stroke}
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <Path
        d='M11.4378 6.32245L13 6.32245'
        stroke={color}
        fill={fill}
        strokeWidth={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M10.3348 3.53906L11.4297 2.43753'
        stroke={color}
        fill={fill}
        strokeWidth={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M7.54901 2.42969L7.54901 0.874183'
        stroke={color}
        fill={fill}
        strokeWidth={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

MobilePhone.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
  stroke: PropTypes.string,
}

export default MobilePhone
